import { render } from "./ESOPTab.vue?vue&type=template&id=12e482d2"
import script from "./ESOPTab.vue?vue&type=script&lang=ts"
export * from "./ESOPTab.vue?vue&type=script&lang=ts"
script.render = render

export default script